import { NgModule } from "@angular/core";
import { HousingListComponent } from "./housing-list/housing-list.component";
import { HousingModalComponent } from "./housing-modal/housing-modal.component";
import { RouterModule } from "@angular/router";
import { ContentHeaderModule } from "../../layout/components/content-header/content-header.module";
import { CoreCommonModule } from "../../../@core/common.module";
import { NgxDatatableModule } from "@siemens/ngx-datatable";
import { NgSelectModule } from "@ng-select/ng-select";
import { SweetAlert2Module } from "@sweetalert2/ngx-sweetalert2";
import { ComponentsModule } from "../../util/components/components.module";
import { NgbAlertModule, NgbNavModule } from "@ng-bootstrap/ng-bootstrap";
import { AuthGuard } from "../../util/guard/auth.guard";
import { OfficesResolver } from "../../util/resolver/offices.resolver";

const routes = [
  {
    path: "housing",
    component: HousingListComponent,
    canActivate: [AuthGuard],
    resolve: {
      offices: OfficesResolver,
    },
  },
];

@NgModule({
  declarations: [HousingListComponent, HousingModalComponent],
  imports: [
    RouterModule.forChild(routes),
    ContentHeaderModule,
    CoreCommonModule,
    NgxDatatableModule,
    NgSelectModule,
    SweetAlert2Module,
    ComponentsModule,
    NgbNavModule,
    NgbAlertModule,
  ],
})
export class HousingModule {}
